<app-form-generator
    [formGeneratorInput]="configurationFormGenInput"
    (formGroupRef)="configurationFormGroup = $event"
></app-form-generator>
